import React from "react";
import Checkbox from "@material-ui/core/Checkbox";

export default function Notificacao(props) {
    const handleChange = (event) => {
        props.setFuncoes({ ...props.funcoes, [event.target.name]: event.target.checked });
    };


    return (
        <>
            <div style={{ maxHeight: 400, overflow: 'auto' }}>
                {
                    props.list_funcoes.map((item, i) => {
                        return (
                            <div style={{ whiteSpace: 'pre-line' }}>
                                {props.funcoes[item._id] === false || props.funcoes[item._id] === true ?
                                    <>
                                        <Checkbox
                                            checked={props.funcoes[item._id]}
                                            onChange={handleChange}
                                            inputProps={{ 'aria-label': 'primary checkbox' }}
                                            name={item._id}
                                        />
                                        {item.funcao}
                                    </>
                                    : null
                                }
                            </div>
                        )
                    })
                }
            </div>
        </>
    )
}
